<template>
  <div>
    <div class="second_nav">
      <ul>
        <li
          @click="nav1(index + 1)"
          @mouseover="onMouseOver1(index)"
          @mouseout="onMouseout1(index)"
          v-for="(item, index) of nav"
          :key="index"
        >
          <img src="../assets/image/patten.png" alt />

          <p class="white" :class="{ p_color: choose == index }">
            {{ item.name }}
          </p>
        </li>
      </ul>
    </div>
    <div></div>
  </div>
</template>
<script>
export default {
  name: "show",
  data() {
    return {
      choose: 9,
      seen: false,
      nav: [{ name: "三维珍品" }]
    };
  },

  methods: {
    nav1(i) {
      (this.choose = i),
        (this.seen = false),
        this.$emit("childByvalue6", this.seen);

      this.$router
        .push({
          path: "/sanwei"
        })
        .catch(err => {
          err;
        });
    },

    onMouseOver1(i) {
      this.choose = i;
    },
    onMouseout1(i) {
      this.choose = 9;
    }
  },
  components: {},
  mounted() {}
};
</script>
<style scoped>
.second_nav {
  width: 100%;
  overflow: hidden;
  height: 50px;
  background: rgb(78, 104, 161);
  border-top: 5px solid rgb(0, 54, 103);
  box-sizing: border-box;
  padding: 0px 584px 0px;
  position: absolute;
  top: 100px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 10000;
}
.second_nav ul {
  display: flex;
  /* width: 100%; */
  height: 30px;
  justify-content: center;

  position: absolute;
  top: 0px;
  left: 600px;
  right: 100px;
  bottom: 0px;
  margin: auto;
}
.second_nav ul li {
  margin: 0 7px 0px;
}
.second_nav ul li:first-child img {
  display: none;
}
.second_nav ul li p {
  font-size: 16px;
  width: 75px;
}
.second_nav ul li img {
  margin-right: 15px;
}
.white {
  /* font-size:24px; */
  font-size: 14px;
  color: white;
}
.second_nav ul li a {
  color: white;
  margin-right: 60px;
  width: 150px;
  font-size: 18px;
  color: white;
  display: flex;
}
.second_nav ul li {
  display: flex;
  justify-content: center;
  align-items: center;
}
li {
  list-style: none;
  text-align: center;
  cursor: pointer;
}
ul,
p {
  margin: 0px;
  padding: 0px;
}
.p_color {
  color: rgb(0, 54, 103);
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/diancangList.vue